import { useCallback, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

import { MdOutlineLogin } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import { UserInfo as UserInfoType } from "types";

import { getUserInfo } from "redux/User/selectors";
import { getShowProfileModal } from "redux/Modals/selectors";
import { setshowProfileModal } from "redux/Modals/actions";
import ThemeToggle from "views/components/ThemeToggle";
import { userLogout } from "redux/authReducer";
import { State } from "redux/store";
import classNames from "classnames";
import UserInfo from "./UserInfo";
import { useFeatureFlagService } from "hooks/useFeatureFlagService";
import { USAGE_REPORT } from "helpers/constants/filters";
import { checkUserQuota } from "redux/User/actions";

import styles from "./style.module.scss";

interface ProfileModalProps {
  showModal: boolean;
  userInfo: UserInfoType;
  userAvatar: string | undefined;
}

function ProfileModal({ userInfo, showModal, userAvatar }: ProfileModalProps) {
  const dispatch = useDispatch();
  const isUsageReportEnabled = useFeatureFlagService(USAGE_REPORT).enabled;

  useEffect(() => {
    if (isUsageReportEnabled) {
      dispatch(checkUserQuota() as any);
    }
  }, [isUsageReportEnabled, dispatch]);

  const innerContainerClassnames = classNames(styles.modalInnerContainer, {
    [styles.wideContainer]: isUsageReportEnabled,
  });

  const closeModal = useCallback(() => {
    dispatch(setshowProfileModal(false));
    //eslint-disable-next-line
  }, [setshowProfileModal]);

  const handleLogout = () => {
    userLogout();
  };
  const listener = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        closeModal();
        document.removeEventListener("keydown", listener);
      }
    },
    [closeModal],
  );

  useEffect(() => {
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [closeModal, listener]);

  return (
    <Modal
      animation={false}
      show={showModal}
      onHide={closeModal}
      className={styles.modalMainContainer}
      backdropClassName={styles.backgroundColor}
    >
      <Modal.Body className={innerContainerClassnames}>
        <div className={styles.optionsListContainer}>
          {(isUsageReportEnabled || userInfo) && (
            <UserInfo userAvatar={userAvatar} userInfo={userInfo} />
          )}

          <ThemeToggle />

          <div className={styles.logoutOptionContainer} onClick={handleLogout}>
            <MdOutlineLogin className={styles.listIcon} size="18px" />
            <span className={styles.logoutOption}>Log Out</span>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state: State) => {
  return {
    userInfo: getUserInfo(state),
    showModal: getShowProfileModal(state),
  };
};
export default connect(mapStateToProps)(ProfileModal);
